export default {
  openMealsSelection,
  closeMealsSelection,
  selectRelationshipType,
  changePassenger,
};

function openMealsSelection (passengerId) {
  if (passengerId !== this.props.activePassenger) {
    this.props.actions.changeActivePassenger(passengerId);
  }
  this.setState({ editOpened: true });
}

function closeMealsSelection () {
  this.props.actions.changeActivePassenger(undefined);
  this.setState({ editOpened: false, selectedPassenger: undefined });
}

function selectRelationshipType (e) {
  this.setState({ relationshipType: e.target.value });
}

/**
 * @param {array} passengers list of passengers
 * @param {string} selectedPassenger ID of currently active passenger
 */
function changePassenger (passengers, selectedPassenger, type) {
  passengers = passengers.sort((a, b) => a.id - b.id);
  selectedPassenger = selectedPassenger || passengers[ 0 ];
  let passengerIndex = 0;
  passengers.find((passenger, index) => {
    if (passenger.id === selectedPassenger) {
      if (type === '-') {
        passengerIndex = index - 1 >= 0 ? index - 1 : passengers.length - 1;
      } else {
        passengerIndex = index + 1 >= passengers.length ? 0 : index + 1;
      }
    }
  });

  let newPassenger = passengers[ passengerIndex ];
  return newPassenger && newPassenger.id ? newPassenger.id : passengers[ 0 ].id;
}



// WEBPACK FOOTER //
// ./src/containers/meals/MealsScreenController.js